angular.module("ainapp")
    .controller("missingAccountsController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Missing Accounts";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }




            $scope.Init = function () {

                $scope.Accounts = [];
                $scope.load = false;

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.GetSameParentAccounts().then(function (response) {
                    if (response.data) {
                        $scope.Accounts = response.data;
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                })



            }
            $scope.Init();





            $scope.moveAccount = function (data) {

                if (data.Level == 1) {
                    toastr.warning("Level 1 Cannot Move");
                } else {

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    $scope.AccountParentList = [];
                    $scope.selectedMoveAccount = data;
                    MainService.GetParentsByAccountType(data.Id).then(function (response) {
                        if (response.data) {
                            $('#moveAccountModal').modal('show');
                            $scope.AccountParentList = response.data;
                        } else {
                            toastr.warning("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                        toastr.error("Network Error");
                    });

                }

            }

            $scope.updateParentAccount = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.UpdateAccountGroup($scope.selectedMoveAccount).then(function (response) {
                    if (response.data) {
                        $('#moveAccountModal').modal('hide');
                        toastr.success("Success");
                        $scope.selectedMoveAccount = {};
                        $scope.resetAcc();
                    } else {
                        toastr.warning("Network Error");
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                });
            }


        }])
